import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {
    Tabs,
    Table,
    Tag,
    Modal,
    Form,
    Radio,
    Select,
    Input,
    Button,
    message,
    PageHeader,
} from 'antd';
import {
    addAppRoom,
    addRoomConfig,
    allowRoom,
    getAppRoom,
    getAppRoomConfigByAppId,
    getAppUsers,
    getConfigForce,
    getRoomMember,
    updateRoomConfig,
} from '@/api/apps';
import dayjs from 'dayjs';
import {EditOutlined, EyeOutlined, PlusOutlined, UserDeleteOutlined, UserOutlined} from '@/icons';

let timeout;
let currentValue;
const {TabPane} = Tabs;
export default function AppRoom({appId, ...props}) {
    const columns = [
        {
            title: '配置类型',
            dataIndex: 'itemType',
            key: 'itemType',
            render: text => {
                if (text === 'room_name') return <Tag color="lime">群名配置</Tag>;
                if (text === 'rule_dep') return <Tag color="green">部门配置</Tag>;
                if (text === 'rule_position') return <Tag color="blue">岗位配置</Tag>;
            },
        },
        {
            title: '配置内容',
            dataIndex: 'itemValue',
            key: 'itemValue',
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text, row) => (
                <>
                    <Button
                        style={{color: '#152D85'}}
                        type="text"
                        icon={<EditOutlined />}
                        onClick={() => {
                            edit(row);
                        }}
                    >
                        编辑
                    </Button>
                </>
            ),
        },
    ];
    const roomColumns = [
        {
            title: '群名',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '群主',
            dataIndex: 'ownerName',
            key: 'ownerName',
            render: (text, row) => <>{text + '(' + row.owner + ')'}</>,
        },
        {
            title: '创建日期',
            dataIndex: 'createTime',
            key: 'createTime',
            render: text => <>{dayjs(parseInt(text)).format('YYYY-MM-DD HH:mm:ss')}</>,
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            render: (text, row) => (
                <>
                    <Button
                        style={{color: '#152D85'}}
                        type="text"
                        icon={<EyeOutlined />}
                        onClick={() => {
                            showDetail(row);
                        }}
                    >
                        查看详情
                    </Button>
                </>
            ),
        },
    ];
    const memberColumns = [
        {
            title: '群成员',
            dataIndex: 'extId',
            key: 'extId',
        },
        {
            title: '状态',
            key: 'status',
            dataIndex: 'status',
            render: text => (
                <>
                    <Tag color="blue" icon={<UserOutlined />}>
                        群成员
                    </Tag>
                </>
            ),
        },
    ];
    const [tableData, setTableData] = useState([]);
    const [roomTableData, setRoomTableData] = useState([]);
    const [nameData, setNameData] = useState([]);
    const [ruleDepData, setRuleDepData] = useState([]);
    const [rulePoData, setRulePoData] = useState([]);
    const [forceData, setForceData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [ownerName, setOwnerName] = useState(null);
    const [memberTableData, setMemberTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isRoomModalVisible, setIsRoomModalVisible] = useState(false);
    const [isConfigModalVisible, setIsConfigModalVisible] = useState(false);
    const [isMemberModalVisible, setIsMemberModalVisible] = useState(false);
    const [title, setTitle] = useState(null);
    const [allow, setAllow] = useState(false);
    const [form] = Form.useForm();
    const [form1] = Form.useForm();
    useEffect(() => {
        appId && initConfig();
        appId && allowRoomConfig();
    }, [appId]);

    function renderTabs() {
        return (
            <Tabs defaultActiveKey="0" onChange={onChange}>
                <TabPane tab="配置" key="1">
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            setIsConfigModalVisible(true);
                            setTitle('新增配置');
                            form1.resetFields();
                        }}
                        disabled={!allow}
                    >
                        添加
                    </Button>
                    <Table
                        style={{margin: '20px 0'}}
                        columns={columns}
                        dataSource={tableData}
                        pagination={false}
                        loading={loading}
                    />
                </TabPane>
                <TabPane tab="群组" key="2">
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => {
                            setIsRoomModalVisible(true);
                            setTitle('新增群组');
                            form.resetFields();
                        }}
                        disabled={!allow}
                    >
                        添加
                    </Button>
                    <Table
                        style={{margin: '20px 0'}}
                        columns={roomColumns}
                        dataSource={roomTableData}
                        pagination={false}
                        loading={loading}
                    />
                </TabPane>
            </Tabs>
        );
    }

    const options = userData.map(d => (
        <Select.Option key={d.extId}>{d.extId + '(' + d.name + '|' + d.email + ')'}</Select.Option>
    ));

    function renderRoomForm() {
        return (
            <div>
                <Form name="basic" layout="vertical" form={form}>
                    <Form.Item
                        label="群名填写"
                        name="roomName"
                        rules={[
                            {
                                required: true,
                                message: '请填写群名',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="部门配置选择"
                        name="ruleDep"
                        rules={[
                            {
                                required: true,
                                message: '请选择部门配置',
                            },
                        ]}
                    >
                        <Select mode="multiple">
                            {ruleDepData.length > 0 &&
                                ruleDepData.map(value => (
                                    <Select.Option value={value.id} key={value.id}>
                                        {value.itemValue}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="岗位配置选择"
                        name="rulePo"
                        rules={[
                            {
                                required: true,
                                message: '请选择岗位配置',
                            },
                        ]}
                    >
                        <Select mode="multiple">
                            {rulePoData.map(value => (
                                <Select.Option value={value.id} key={value.id}>
                                    {value.itemValue}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="是否强制加入"
                        name="join"
                        rules={[
                            {
                                required: true,
                                message: '请选择配置',
                            },
                        ]}
                    >
                        {forceData.length > 0 && (
                            <Radio.Group>
                                {forceData.map(value => (
                                    <Radio value={value.id} key={value.id}>
                                        {value.itemValue}
                                    </Radio>
                                ))}
                            </Radio.Group>
                        )}
                    </Form.Item>
                    <Form.Item
                        label="群主选择"
                        required
                        name="owner"
                        rules={[
                            {
                                required: true,
                                message: '请选择群组',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={handleSearch}
                            notFoundContent={null}
                        >
                            {options}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="群员选择"
                        name="members"
                        rules={[
                            {
                                required: true,
                                message: '请选择群员,最多选择四个成员',
                                validator: changeValues,
                                validateTrigger: 'onChange',
                            },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            showSearch
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={handleSearch}
                            notFoundContent={null}
                        >
                            {options}
                        </Select>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    function renderConfigForm() {
        return (
            <div>
                <Form name="basic" layout="vertical" form={form1}>
                    <Form.Item label="ID" name="id" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="配置内容"
                        name="itemValue"
                        rules={[
                            {
                                required: true,
                                message: '请填写配置内容',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="规则选择"
                        name="itemType"
                        rules={[
                            {
                                required: true,
                                message: '请选择规则',
                            },
                        ]}
                    >
                        <Radio.Group>
                            <Radio value="rule_dep" key="rule_dep">
                                部门规则
                            </Radio>
                            <Radio value="rule_position" key="rule_position">
                                岗位规则
                            </Radio>
                        </Radio.Group>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    function changeValues(rule, value, callback) {
        const {setFieldsValue} = form;
        let newArr;
        if (value.length >= 5) {
            newArr = [].concat(value.slice(0, 2), value.slice(-1));
            setFieldsValue({
                members: newArr,
            });
            callback('最多选择四个成员');
        } else {
            newArr = value;
            callback();
        }
    }

    function allowRoomConfig() {
        allowRoom(appId).then(res => {
            console.log(res);
            setAllow(res.data);
        });
    }

    function initConfig() {
        setLoading(true);
        getAppRoomConfigByAppId(appId).then(res => {
            // setRuleData(res.data);
            // 拆分数据
            let {data} = res;
            let [tableData, nameData, ruleDepData, rulePoData] = [[], [], []];
            if (data.length > 0) {
                tableData = data.filter(
                    value => value.itemType !== 'rule_force' && value.itemType !== 'room_name'
                );
                nameData = data.filter(value => value.itemType == 'room_name');
                ruleDepData = data.filter(value => value.itemType == 'rule_dep');
                rulePoData = data.filter(value => value.itemType == 'rule_position');
                // forceData = data.filter(value => value.itemType === 'rule_force');
                setTableData(tableData);
                setNameData(nameData);
                // setForceData(forceData);
                setRuleDepData(ruleDepData);
                setRulePoData(rulePoData);
            }
            getAppRoom(appId).then(res => {
                console.log(res);
                setRoomTableData(res.data);
                setLoading(false);
            });
        });
        getConfigForce().then(res => {
            let {data} = res;
            let [forceData] = [[]];
            if (data.length > 0) {
                forceData = data;
                setForceData(forceData);
            }
        });
    }

    function formSubmit() {
        form.validateFields().then(value => {
            value.appId = appId;
            addAppRoom(value).then(res => {
                console.log(res);
                message.success('保存成功');
                setIsRoomModalVisible(false);
                initConfig();
            });
        });
    }

    function configFormSubmit() {
        form1.validateFields().then(value => {
            value.appId = appId;
            console.log(value);
            if (typeof value.id == 'undefined') {
                addRoomConfig(value).then(res => {
                    message.success('保存成功');
                    setIsConfigModalVisible(false);
                    initConfig();
                });
            } else {
                updateRoomConfig(value).then(res => {
                    message.success('修改成功');
                    setIsConfigModalVisible(false);
                    initConfig();
                });
            }
        });
    }

    const handleSearch = newValue => {
        if (newValue) {
            fetch(newValue, setUserData);
        } else {
            setUserData([]);
        }
    };

    const fetch = (value, callback) => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }

        currentValue = value;

        const fake = () => {
            const str = value;
            getAppUsers(str).then(res => {
                console.log(res);
                callback(res.data);
            });
        };

        timeout = setTimeout(fake, 300);
    };

    function onChange() {
        console.log(1);
    }

    function showDetail(record) {
        console.log(record);
        getRoomMember(record.chatId).then(res => {
            setMemberTableData(res.data);
            setOwnerName(record.ownerName);
            setTitle('群成员');
            setIsMemberModalVisible(true);
        });
    }

    function edit(row) {
        setIsConfigModalVisible(true);
        setTitle('编辑配置');
        form1.setFieldsValue(row);
    }

    return (
        <PageHeader title={`群组创建`} style={{overflowY: 'auto'}}>
            {renderTabs()}
            <Modal
                title={title}
                visible={isMemberModalVisible}
                onOk={() => setIsMemberModalVisible(false)}
                onCancel={() => setIsMemberModalVisible(false)}
            >
                <Table columns={memberColumns} dataSource={memberTableData} pagination={false} />
            </Modal>
            <Modal
                title={title}
                visible={isConfigModalVisible}
                onOk={() => configFormSubmit()}
                onCancel={() => setIsConfigModalVisible(false)}
            >
                {!loading && renderConfigForm()}
            </Modal>
            <Modal
                title={title}
                visible={isRoomModalVisible}
                onOk={() => formSubmit()}
                onCancel={() => setIsRoomModalVisible(false)}
            >
                {!loading && renderRoomForm()}
            </Modal>
        </PageHeader>
    );
}

AppRoom.propTypes = {
    appId: PropTypes.string.isRequired,
};
